import React from "react";

// Helper to underline and bold only the <u>...</u> part in the question string
function renderQuestionWithUnderline(question) {
    if (typeof question !== 'string') {
        return { __html: '' };
    }
    return {
        __html: question.replace(
            /（\s*）|\(\s*\)/,
            '<span style="font-weight:bold;">（　）</span>'
        )
    };
}

const N4BunpooQ3 = ({
    questions,
    selectedAnswers,
    showResult,
    handleAnswerChange,
}) => {
    if (!questions || questions.length === 0) return null;

    return (
        <div>
            <div
                style={{
                    fontSize: "1.2rem",
                    marginBottom: "1rem",
                    fontWeight: 'lighter',
                    background: '#f8faff',
                    padding: '1.5rem',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(25,118,210,0.07)'
                }}
            >
                <div style={{ fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '1rem' }}>
                    問題３:　18)から21)に 何を 入れますか。文章の 意味を 考えて、1・2・3・4から いちばん いい ものを 一つえらんで ください。                </div>

                {/* Centered title */}
                {questions[0]?.content && (
                    <div style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontSize: '1.2rem',
                        marginBottom: '2rem',
                        padding: '1rem',
                        borderBottom: '1px solid #e0e0e0'
                    }}>
                        {questions[0].content.match(/<span>(.*?)<\/span>/)?.[1] || ''}
                    </div>
                )}

                {/* Rest of the content */}
                {questions[0]?.content && (
                    <div dangerouslySetInnerHTML={{
                        __html: questions[0].content.replace(/<div style.*?span>.*?<\/span><\/div>/, '') || ''
                    }} />
                )}
            </div>

            <ul style={{ listStyle: 'none', padding: 0 }}>
                {questions.map((item, idx) => (
                    <li
                        key={item.id}
                        style={{
                            marginBottom: '2.5rem',
                            width: '100%',
                            background: '#f8faff',
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(25,118,210,0.07)',
                            padding: '1.2rem'
                        }}
                    >
                        <div style={{ marginBottom: '1rem', fontSize: '1.2rem', fontWeight: 500 }}>
                            <span style={{ marginRight: 12 }}>【{idx + 18}】</span>
                            <span dangerouslySetInnerHTML={renderQuestionWithUnderline(item.question)} />
                        </div>
                        {item.answers && item.answers.length === 4 && (
                            <div style={{ width: '100%' }}>
                                {[0, 2].map(rowStart => (
                                    <div
                                        key={rowStart}
                                        style={{
                                            display: 'flex',
                                            gap: '1.5rem',
                                            marginBottom: '0.7rem',
                                        }}
                                    >
                                        {[0, 1].map(col => {
                                            const ansIdx = rowStart + col;
                                            const ans = item.answers[ansIdx];
                                            const isSelected = selectedAnswers[item.id] === ansIdx;
                                            let color = undefined;
                                            if (showResult) {
                                                if (ansIdx === item.correct) {
                                                    color = 'green';
                                                } else if (isSelected && ansIdx !== item.correct) {
                                                    color = 'red';
                                                }
                                            }
                                            return (
                                                <label
                                                    key={ansIdx}
                                                    style={{
                                                        flex: 1,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '0.8rem 1rem',
                                                        borderRadius: '6px',
                                                        border: '1px solid #e0e0e0',
                                                        background: '#fff',
                                                        cursor: showResult ? 'default' : 'pointer',
                                                        fontSize: '1.2rem',
                                                        fontWeight: isSelected ? 700 : 500,
                                                        textDecoration: isSelected ? 'underline' : 'none',
                                                        color: color,
                                                        transition: 'all 0.2s',
                                                        wordBreak: 'break-word',
                                                        boxSizing: 'border-box'
                                                    }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`question-${item.id}`}
                                                        value={ansIdx}
                                                        checked={isSelected}
                                                        onChange={() => handleAnswerChange(item.id, ansIdx)}
                                                        disabled={showResult}
                                                        style={{
                                                            marginRight: 14,
                                                            accentColor: "#1976d2",
                                                            width: 22,
                                                            height: 22
                                                        }}
                                                    />
                                                    {ans}
                                                    {showResult && ansIdx === item.correct && (
                                                        <span style={{ marginLeft: 10, fontWeight: 'bold', fontSize: '1.2rem' }}>✓</span>
                                                    )}
                                                    {showResult && isSelected && ansIdx !== item.correct && (
                                                        <span style={{ marginLeft: 10, fontWeight: 'bold', fontSize: '1.2rem', color: 'red' }}>✗</span>
                                                    )}
                                                </label>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default N4BunpooQ3;
